import { getLoyaltyConfiguration } from '@omnia/ui/src/lib/lumos-plus/domain/selectors/get-loyalty-configuration'
import { getLoyaltyLanguageText } from '@omnia/ui/src/lib/lumos-plus/domain/selectors/get-loyalty-language-text'
import type { MemberBalanceProps } from '@vista-digital/occ-ui/src'
import { MemberBalancePrimaryValue } from '@vista-digital/occ-ui/src'
import type { NestedPartial } from '@vista-digital/utilities/src'

export const getMemberBalanceProps = (): NestedPartial<MemberBalanceProps> => {
    const config = getLoyaltyConfiguration()
    const { memberOverview } = getLoyaltyLanguageText({
        contentName: 'OverviewPage',
    })

    return {
        displayText: memberOverview?.omnichannel?.memberBalance,
        config: config?.memberBalance ?? {
            primaryValue: MemberBalancePrimaryValue.MonetaryValue,
            showSecondaryValue: false,
        },
    }
}
